import {createSlice} from "@reduxjs/toolkit";
import {extraReducers} from "./action";

const initialState = {
    items: [],
    loadingStatus: 'loaded',
}

const dynamicSlice = createSlice({
        name: 'dynamicPageInfo',
        initialState,
        reducers: {
            setMockPage: (state, action) => {
                state.loadingStatus = 'loaded';
                state.items = action.payload;
            }
        },
        extraReducers: extraReducers
    }
);

const {actions, reducer} = dynamicSlice;

export const { setMockPage } = actions;
export default reducer;

export const {fetchSort} = actions;
